<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription">
        <header
          class="modal-header"
          id="modalTitle">
          <slot name="header">
            <p class="modal-title">Default title</p>
          </slot>
          <button
            type="button"
            class="btn-close"
            @click="onCancel"
            aria-label="Close modal">
            <i class="fas fa-times"></i>
          </button>
        </header>
        <section
          class="modal-body"
          id="modalDescription">
          <slot name="body" v-bind:model="model">
            <p class="modal-content">Default body</p>
          </slot>
        </section>
        <footer class="modal-footer">
          <button class="ghost-button" type="button" @click="onCancel">{{$t("actions.cancel")}}</button>
          <button class="solid-button" type="button" @click="onConfirm">{{actionLabel}}</button>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    name: 'simpleModal',
    props: {
      model: {
        type: Object,
        default: function () {
          return {}
        }
      },
      actionLabel: {
        type: String,
        default: function () {
          return this.$t("actions.delete")
        }
      }
    },
    methods: {
      onConfirm() {
        this.$emit("confirm");
      },
      onCancel() {
        this.$emit("cancel");
      }
    },
  };
</script>
<style lang="scss" scoped>
  @import '../style/form.scss';

  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9000;
  }

  .modal {
    background: white;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer,
  .modal-body {
    padding: 20px;
    display: flex;
    align-items: center;
  }

  .modal-header {
    border-bottom: 1px solid $bluish-grey-50;
    justify-content: space-between;
  }

  .modal-body {
    justify-content: flex-start;
  }

  .modal-footer {
    justify-content: flex-end;
  }

  .modal-footer :not(:first-child) {
    margin-left: 15px;
  }

  .btn-close {
    border: none;
    cursor: pointer;
    font-size: 25px;
    opacity: 0.7;
    color: $bluish-grey;
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/simpleModal.vue